import React, {useState, useEffect} from "react";
import Menu from "../../../../components/layout/menu/index";
import { useTable } from "react-table";
import updateImage from "../../../../assets/images/icons/shared/updateImage.svg"
import { getEvaluationSupplier, remmainingAttempts } from "../../../../client/evaluationProvider";
import { useAuth } from "../../../../context/auth";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import ModalSuccess from "../../../../components/shared/modals/modalSuccess";
import ModalAlertWarning from "../../../../components/shared/modals/modalAlertWarning"
import { sendWorkPlanMail } from "../../../../client/evaluationProvider";
import { useModuleAdherence } from "../../../../hooks/userAdherence";
import plantrabajo from "../../../../assets/images/icons/plan_trabajo.svg"

const EvaluationChart = ({ data }) => {
  if (!data || data.length === 0) return null;

const renderMultilineXAxisTick = ({ x, y, payload }) => {
  const MAX_LINE_LENGTH = 14;
  const MAX_LINES = 6; // Máximo de líneas a mostrar
  const text = payload.value;
  
  const splitLongWord = (word) => {
    const chunks = [];
    let remaining = word;
    
    while (remaining.length > 0) {
      const chunk = remaining.slice(0, MAX_LINE_LENGTH - 1);
      remaining = remaining.slice(MAX_LINE_LENGTH - 1);
      chunks.push(chunk + (remaining.length > 0 ? "-" : ""));
    }
    return chunks;
  };

  const lines = [];
  let currentLine = "";
  
  text.split(" ").forEach(word => {
    if (word.length > MAX_LINE_LENGTH) {
      const wordChunks = splitLongWord(word);
      wordChunks.forEach(chunk => {
        if ((currentLine + chunk).length >= MAX_LINE_LENGTH) {
          lines.push(currentLine);
          currentLine = chunk;
        } else {
          currentLine += chunk;
        }
      });
    } else {
      if ((currentLine + " " + word).length > MAX_LINE_LENGTH) {
        lines.push(currentLine);
        currentLine = word;
      } else {
        currentLine += (currentLine ? " " : "") + word;
      }
    }
  });

  if (currentLine) lines.push(currentLine);

  const lineHeight = 15;
  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={8}
        textAnchor="middle"
        className="font-itcbook"
        fill="#4B5563"
        fontSize={9}
      >
        {lines.slice(0, MAX_LINES).map((line, index) => (
          <tspan
            key={index}
            x={0}
            dy={index === 0 ? 0 : lineHeight}
            alignmentBaseline="middle"
          >
            {line}
          </tspan>
        ))}
      </text>
    </g>
  );
};

  return (
    <div className="relative w-full h-[250px] px-3 p-2 bg-white shadow-md rounded-[10px]">
      <h2 className="text-blue text-[16px] font-itcbold">
        Indicadores
      </h2>
      <SimpleBar className="w-full overflow-x-auto ">
        <div className="lg:w-full  w-[600px] h-[230px] lg:h-[250px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={data.map(item => ({
                name: item.criterionName,
                score: item.score,
                peso: item.weight_criterion
              }))}
              layout="horizontal" 
              margin={{
                top: 30,
                right: 0,
              }}
              barSize={30}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                type="category"
                dataKey="name"
                tick={renderMultilineXAxisTick}
                interval={0}
                height={80} 
                tickLine={false}
                tickMargin={3}
              />
              
              <Tooltip 
                formatter={(value) => [`${value}%`, 'Puntuación']}
                labelFormatter={(name) => `Criterio: ${name}`}
              />
              <Bar 
                dataKey="score" 
                name="Puntuación (%)" 
                fill="#184A7D" 
                radius={[4, 4, 0, 0]}
                label={{ 
                  position: 'top', 
                  formatter: (value) => `${value}%`,
                  style: { fontSize: 12 } 
                }}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </SimpleBar>
    </div>
  );
};

const Table = ({ data}) => {
    const columns = React.useMemo(() => [
        {
          Header: 'Peso',
          accessor: 'weight_criterion',
          style: { minWidth: '155px' },
          Cell: ({ value }) => `${value}%`
        },
        {
          Header: 'Criterio',
          accessor: 'criterionName',
          style: { minWidth: '227px' } 
        },
        {
          Header: 'Nota',
          accessor: 'score',
          style: { minWidth: '155px' } ,
                  Cell: ({ value }) => (
            <span className="font-itcbold">
                {value}%
            </span>
        )
        },
        {
          Header: '¿Cómo se calcula este criterio?',
          accessor: 'description',
          style: { minWidth: '402px' },
        },
      ], []);

  const tableInstance = useTable({ columns, data });

  return (
<SimpleBar className="w-full overflow-x-auto">
          <table
           {...tableInstance.getTableProps()} 
           className="w-full border-separate table-auto border-spacing-4"
           >
          <thead>
            {tableInstance.headerGroups.map(headerGroup => (
              <tr {...headerGroup.getHeaderGroupProps()} className="text-[20px] h-[60px] text-white font-itcbold ">
                {headerGroup.headers.map(column => (
                  <th {...column.getHeaderProps()}
                  style={column.style}
                   className="p-2 text-center align-middle rounded-[16px]  bg-[#184A7D] ">{column.render('Header')}</th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...tableInstance.getTableBodyProps()}>
            {tableInstance.rows.map(row => {
              tableInstance.prepareRow(row);
              return (
                <tr {...row.getRowProps()} className={`text-base text-center h-[73px] font-itcbook `}>
                  {row.cells.map(cell => (
                    <td {...cell.getCellProps()} className="p-2 align-middle rounded-[16px] text-white bg-[#00769699]">{cell.render('Cell')}</td>
                  ))}
                </tr>
              );
            })}
          </tbody>
          </table>
</SimpleBar>
  );
};

export default function Evaluation() {
  useModuleAdherence(9);

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const {supplierId, user} = useAuth();
  const [supplierData, setSupplierData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showScoreInfo, setShowScoreInfo] = useState(false);
  const [showModalUploadDocument, setShowModalUploadDocument] = useState(false);


const [selectedFile, setSelectedFile] = useState(null);
const [showModalSuccess, setShowModalSuccess] = useState(false);
const [isSending, setIsSending] = useState(false);

const [remainingAttempts, setRemainingAttempts] = useState(null);

const [showAlertWarning, setShowAlertWarning] = useState(false);
const [alertMessage, setAlertMessage] = useState("");

const ALLOWED_FILE_TYPES = {
  '.pdf': 'application/pdf',
  '.xls': 'application/vnd.ms-excel',
  '.xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  '.csv': 'text/csv',
  '.jpg': 'image/jpeg',
  '.jpeg': 'image/jpeg',
  '.png': 'image/png',
  '.webp': 'image/webp',
  '.svg': 'image/svg+xml; charset=utf-8',
  '.doc': 'application/msword',
  '.docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  '.odt': 'application/vnd.oasis.opendocument.text',
  '.ods': 'application/vnd.oasis.opendocument.spreadsheet',
  '.ppt': 'application/vnd.ms-powerpoint',
  '.pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  '.odp': 'application/vnd.oasis.opendocument.presentation'
};

const ALLOWED_EXTENSIONS = Object.keys(ALLOWED_FILE_TYPES);
const MAX_TOTAL_SIZE_MB = 50;
const MAX_TOTAL_SIZE_BYTES = MAX_TOTAL_SIZE_MB * 1024 * 1024;


const fetchRemainingAttempts = async () => {
  try {
    if (supplierId) {
      const response = await remmainingAttempts(supplierId);
      setRemainingAttempts(response.data.attemptsRemmaining);
    }
  } catch (error) {
    console.error('Error fetching remaining attempts:', error);
  }
};

useEffect(() => {
  fetchRemainingAttempts();
}, [supplierId]);

const handleFileUpload = (file) => {
  if (Array.isArray(file)) {
    setAlertMessage('Solo se permite un archivo');
    setShowAlertWarning(true);
    return;
  }

  const fileName = file.name.toLowerCase();
  const isValidExtension = ALLOWED_EXTENSIONS.some(ext => fileName.endsWith(ext));
  
  if (!isValidExtension) {
    const validExtensions = ALLOWED_EXTENSIONS.join(', ');
    setAlertMessage(`Solo se permiten archivos con las siguientes extensiones: ${validExtensions}`);
    setShowAlertWarning(true);
    return;
  }

  if (file.size > MAX_TOTAL_SIZE_BYTES) {
    setAlertMessage(`El archivo no debe exceder ${MAX_TOTAL_SIZE_MB} MB`);
    setShowAlertWarning(true);
    return;
  }

  setSelectedFile(file);
};

const handleFileSelect = (file) => {
  handleFileUpload(file);
  setShowModalUploadDocument(false);
};

const handleSendWorkPlan = async () => {
  if (!selectedFile) {
    setAlertMessage('Debe seleccionar un archivo primero');
    setShowAlertWarning(true);
    return;
  }

  setIsSending(true);
  try {
    const response = await sendWorkPlanMail(
      selectedFile, 
      supplierId, 
      user.email 
    );
    setShowModalSuccess(true);
    setSelectedFile(null); 
  } catch (error) {
    console.error('Error al enviar el plan de trabajo:', {
      error: error,
      response: error.response,
      data: error.response?.data,
      status: error.response?.status
    });
    setAlertMessage('Error al enviar el plan de trabajo. Por favor intente nuevamente.');
    setShowAlertWarning(true);
  } finally {
    setIsSending(false);
  }
};


  useEffect(() => {
    const fetchSupplierData = async () => {
      try {
        if (supplierId) {
          const response = await getEvaluationSupplier(supplierId);

          setSupplierData(response.data);
        }
      } catch (error) {
        console.error('Error fetching supplier data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSupplierData();
  }, [supplierId]);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); 
    const year = date.getFullYear();
    
    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showScoreInfo && !event.target.closest('.relative')) {
        setShowScoreInfo(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showScoreInfo]);

  return (
    <div>
        <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300"/>
        <div className={`flex-1 pt-[67px] transition-all duration-300 ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"} bg-[#F7F8F9] w-full z-50 min-h-screen`}>
            <div className="pt-2 sm:pt-8 pb-10 px-[3%] flex flex-col gap-4">
                <div className="flex flex-col items-center justify-between gap-2 sm:flex-row">
                  <h1 className="text-blue font-itcmedium md:text-[32px] text-2xl">
                    Hola, {supplierData?.supplierName}
                  </h1>
                  <div className="flex items-center justify-center gap-2">
                    {(() => {
                      const score = supplierData?.evaluation?.final_score || 0;
                      const colorClass = 
                        score >= 85 ? 'text-[#80D402] bg-[#80D402]' :
                        score >= 70 ? 'text-[#D1E901] bg-[#D1E901]' :
                        score >= 60 ? 'text-[#FFEB13] bg-[#FFEB13]' :
                        'text-[#FCB42F] bg-[#FCB42F]';
                      
                      const text = 
                        score >= 85 ? 'Apto Bueno' :
                        score >= 70 ? 'Apto Regular' :
                        score >= 60 ? 'Apto Reservado' :
                        'Deficiente';

                      return (
                        <>
                          <p className={`font-itcmedium ${colorClass.split(' ')[0]}`}>
                            {text}
                          </p>
                          <div className={`w-[58px] h-[22px] rounded-[11px] ${colorClass.split(' ')[1]}`}></div>
                        </>
                      );
                    })()}
                    <div className="relative">
                      <button
                        onClick={() => setShowScoreInfo(!showScoreInfo)}
                        className="flex items-center justify-center cursor-pointer">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 15C10.2833 15 10.521 14.904 10.713 14.712C10.905 14.52 11.0007 14.2827 11 14V10C11 9.71667 10.904 9.47933 10.712 9.288C10.52 9.09667 10.2827 9.00067 10 9C9.71733 8.99933 9.48 9.09533 9.288 9.288C9.096 9.48067 9 9.718 9 10V14C9 14.2833 9.096 14.521 9.288 14.713C9.48 14.905 9.71733 15.0007 10 15ZM10 7C10.2833 7 10.521 6.904 10.713 6.712C10.905 6.52 11.0007 6.28267 11 6C10.9993 5.71733 10.9033 5.48 10.712 5.288C10.5207 5.096 10.2833 5 10 5C9.71667 5 9.47933 5.096 9.288 5.288C9.09667 5.48 9.00067 5.71733 9 6C8.99933 6.28267 9.09533 6.52033 9.288 6.713C9.48067 6.90567 9.718 7.00133 10 7ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88334 18.6867 3.825 17.9743 2.925 17.075C2.025 16.1757 1.31267 15.1173 0.788001 13.9C0.263335 12.6827 0.000667933 11.3827 1.26582e-06 10C-0.000665401 8.61733 0.262001 7.31733 0.788001 6.1C1.314 4.88267 2.02633 3.82433 2.925 2.925C3.82367 2.02567 4.882 1.31333 6.1 0.788C7.318 0.262667 8.618 0 10 0C11.382 0 12.682 0.262667 13.9 0.788C15.118 1.31333 16.1763 2.02567 17.075 2.925C17.9737 3.82433 18.6863 4.88267 19.213 6.1C19.7397 7.31733 20.002 8.61733 20 10C19.998 11.3827 19.7353 12.6827 19.212 13.9C18.6887 15.1173 17.9763 16.1757 17.075 17.075C16.1737 17.9743 15.1153 18.687 13.9 19.213C12.6847 19.739 11.3847 20.0013 10 20Z" fill="#184A7D"/>
                        </svg>
                      </button>
                      {showScoreInfo && (
                      <div className={`absolute shadow-[0px_4px_5.2px_2px_rgba(0,0,0,0.25)] w-[303px] text-[#184A7D] p-4 -right-16 sm:right-0 z-10 flex flex-col gap-3 bg-white rounded-lg top-8 transition-all duration-300 ${showScoreInfo ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2 pointer-events-none'}`}>                        <p className="font-itcbold text-[20px]">Nota aprobatoria: 80%</p>
                        <div className="flex items-center gap-2">
                          <div className="bg-[#80D402] w-[58px] h-[22px] rounded-[11px]"></div>
                          <p className="text-[#184A7D] font-itcmedium">Apto Bueno 85 - 100%</p>
                        </div>
                        <div className="flex items-center gap-2">
                          <div className="bg-[#D1E901] w-[58px] h-[22px] rounded-[11px]"></div>
                          <p className="text-[#184A7D] font-itcmedium">Apto Regular 70 - 84%</p>
                        </div>
                        <div className="flex items-center gap-2">
                          <div className="bg-[#FFEB13] w-[58px] h-[22px] rounded-[11px]"></div>
                          <p className="text-[#184A7D] font-itcmedium">Apto Reservado 60 - 69%</p>
                        </div>
                        <div className="flex items-center gap-2">
                          <div className="bg-[#FCB42F] w-[58px] h-[22px] rounded-[11px]"></div>
                          <p className="text-[#184A7D] font-itcmedium">Deficiente {'<'} 60%</p>
                        </div>
                      </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="flex font-itcbook  flex-col text-xl md:text-2xl text-[#6B7280]">
                  <p>
                    Tu evaluación de desempeño de proveedor es de
                      <span className="text-blue font-itcdemi">
                        {' '}{supplierData?.evaluation.final_score}% 
                      </span>
                      <span>
                        {' '}(al {formatDate(supplierData?.evaluation?.created_At)})
                      </span>
                  </p>
                  <p>
                    Conoce el detalle de tu evaluación:
                  </p>
                </div>

                {supplierData?.detailEvaluations && (
                    <Table data={supplierData.detailEvaluations}/>
                )}

                <div className="bg-[#5CBDEB4D] bg-opacity-30 flex flex-col items-start md:flex-row gap-6 p-6 w-full h-auto rounded-2xl">
                  <div className="flex flex-col w-full md:w-[50%] gap-2">
                    <h2 className="text-blue text-[24px] font-itcmedium">
                      Análisis
                    </h2>
                    <p className="font-itcbook text-justify text-[4.2vw] sm:text-[2.8vw] lg:text-[1.2vw] text-[#2F2F3B]">
                      {supplierData?.evaluation.analysis}
                    </p>
                  </div>
                  <div className=" md:w-[50%] w-full ">
                    {supplierData?.detailEvaluations && (
                      <EvaluationChart data={supplierData.detailEvaluations}/>
                    )}
                  </div>
                </div>

                <div className="grid items-start grid-cols-1 gap-8 md:grid-cols-2">
                  <div className="bg-[#5CBDEB4D] gap-2 flex flex-col  bg-opacity-30 rounded-2xl p-6">
                    <h2 className="text-blue text-[24px] font-itcmedium">
                      Recomendaciones
                    </h2>
                    <p className="font-itcbook text-justify text-[4.2vw] sm:text-[2.8vw] lg:text-[1.2vw] text-[#2F2F3B]">
                      {supplierData?.evaluation.recommendations}
                    </p>
                  </div>
                  <div className="bg-[#5CBDEB4D] rounded-2xl flex flex-col gap-4 p-6 justify-between items-center self-start">
                    <h2 className="text-blue text-center text-[24px] font-itcmedium">
                      Inserta tu plan de trabajo
                    </h2>
                    <div className="flex flex-col items-center justify-center w-full">
                      <button
                          disabled={remainingAttempts <= 0}
                          onClick={() => setShowModalUploadDocument(true)}
                          className={`bg-white p-4 w-[80%] border-dashed rounded-[15px] border border-[#666666] flex flex-col items-center justify-center gap-4 
                          ${remainingAttempts <= 0 ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
                          {selectedFile ? (
                            <div className="relative flex items-center justify-center w-full gap-3">
                              <div className="flex flex-col items-center gap-2">
                                <img src={plantrabajo} alt="Plan de trabajo" className="w-6 h-6" />
                                <p className="text-[#3F3F3F] font-itcbook text-[12px] truncate max-w-[150px]">
                                  {selectedFile.name}
                                </p>
                              </div>
    <button
      onClick={(e) => {
        e.stopPropagation(); 
        setSelectedFile(null);
      }}
      className="absolute -top-2 -right-2 text-[#6B7280] hover:text-red-500 transition-colors rounded-full p-0.5 "
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </button>
                            </div>
                          ) : (
                            <>
                              <img src={updateImage} alt="Sube tu plan de trabajo"/>
                              <p className="text-[#3F3F3F] font-itcbook text-[10px]">
                                Sube tu plan de trabajo
                              </p>
                            </>
                          )}


                      
                      </button>   
                    </div>

                    <div className="flex items-center justify-center">
                      <button 
                        onClick={handleSendWorkPlan}
                        disabled={!selectedFile || isSending}
                        className={`underline text-[15px] font-itcdemi ${(!selectedFile || isSending) ? 'opacity-50 text-[#6B7280] cursor-not-allowed' : 'text-blue'}`}
                      >
                        {isSending ? 'Enviando...' : 'Enviar'}
                      </button>
                    </div>
                    <p className=" font-itcbold pl-2 pt-2 text-[12px]">Intentos restantes: {remainingAttempts} </p>
                  </div>
                </div>
            </div>
        </div>
        {showModalUploadDocument && (
          <div className="fixed inset-0 z-50 flex items-center justify-center w-full bg-black bg-opacity-50">
            <div className="lg:w-[25%] w-[85%] h-auto bg-white border-dashed border border-[#666666] rounded-2xl shadow-lg flex flex-col pb-4">
              <div className='flex justify-end'>
                <button
                  onClick={() => setShowModalUploadDocument(false)}
                  className="px-4 py-2 rounded-md"
                >
                  <img src={require("../../../../config/images").MODALS.CLOSE} alt="cerrar"/>
                </button>
              </div>
              <div className='flex flex-col items-center justify-center gap-6 px-8 pb-4'>
                <input
                  type="file"
                  id="file-upload-custom"
                  accept={ALLOWED_EXTENSIONS.join(',')}
                  className="hidden"
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) {
                      handleFileSelect(file);
                    }
                    e.target.value = '';
                  }}
                />
                <label htmlFor="file-upload-custom" className="flex flex-col items-center gap-4 cursor-pointer">
                  <svg width="42" height="44" viewBox="0 0 42 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 6.375C10 4.7174 10.6585 3.12769 11.8306 1.95558C13.0027 0.78348 14.5924 0.125 16.25 0.125H27.4563C28.699 0.126094 29.8905 0.620672 30.7687 1.5L39.8781 10.6063C40.7563 11.485 41.2497 12.6764 41.25 13.9187V37.625C41.25 39.2826 40.5915 40.8723 39.4194 42.0444C38.2473 43.2165 36.6576 43.875 35 43.875H24.5719C25.8318 42.9893 26.967 41.9382 27.9469 40.75H35C35.8288 40.75 36.6237 40.4208 37.2097 39.8347C37.7958 39.2487 38.125 38.4538 38.125 37.625V15.75H30.3125C29.0693 15.75 27.877 15.2561 26.9979 14.3771C26.1189 13.498 25.625 12.3057 25.625 11.0625V3.25H16.25C15.4212 3.25 14.6263 3.57924 14.0403 4.16529C13.4542 4.75134 13.125 5.5462 13.125 6.375V12.6937C12.0677 12.7895 11.0216 12.9831 10 13.2719V6.375ZM30.3125 12.625H37.4781L28.75 3.89688V11.0625C28.75 11.4769 28.9146 11.8743 29.2076 12.1674C29.5007 12.4604 29.8981 12.625 30.3125 12.625ZM14.6875 43.875C16.5342 43.875 18.3628 43.5113 20.069 42.8046C21.7751 42.0979 23.3254 41.062 24.6312 39.7562C25.937 38.4504 26.9729 36.9001 27.6796 35.194C28.3863 33.4878 28.75 31.6592 28.75 29.8125C28.75 27.9658 28.3863 26.1372 27.6796 24.431C26.9729 22.7249 25.937 21.1746 24.6312 19.8688C23.3254 18.563 21.7751 17.5272 20.069 16.8204C18.3628 16.1137 16.5342 15.75 14.6875 15.75C10.9579 15.75 7.38104 17.2316 4.74381 19.8688C2.10658 22.506 0.625 26.0829 0.625 29.8125C0.625 33.5421 2.10658 37.119 4.74381 39.7562C7.38104 42.3934 10.9579 43.875 14.6875 43.875ZM22.0438 28.7062C22.3371 28.9996 22.502 29.3976 22.502 29.8125C22.502 30.2274 22.3371 30.6254 22.0438 30.9188C21.7504 31.2121 21.3524 31.377 20.9375 31.377C20.5226 31.377 20.1246 31.2121 19.8312 30.9188L16.25 27.3344V36.0625C16.25 36.4769 16.0854 36.8743 15.7924 37.1674C15.4993 37.4604 15.1019 37.625 14.6875 37.625C14.2731 37.625 13.8757 37.4604 13.5826 37.1674C13.2896 36.8743 13.125 36.4769 13.125 36.0625V27.3344L9.54375 30.9188C9.25035 31.2121 8.85242 31.377 8.4375 31.377C8.02258 31.377 7.62465 31.2121 7.33125 30.9188C7.03785 30.6254 6.87303 30.2274 6.87303 29.8125C6.87303 29.3976 7.03785 28.9996 7.33125 28.7062L13.5812 22.4562C13.8725 22.1657 14.2667 22.0017 14.6781 22H14.6969C15.1042 22.0025 15.4944 22.164 15.7844 22.45L15.7938 22.4594L22.0438 28.7062Z" fill="#007696" />
                  </svg>
                  <p className="text-[16px] font-itcbook text-gray">
                    Sube tu archivo aquí
                  </p>
                        <p className="text-[10px] text-center text-[#6B7280] font-itcbook">
                        Formatos permitidos: CSV o XLSX<br />
                        Peso máx. 50 MB
                        </p>
                </label>
              </div>
            </div>
          </div>
        )}

        <ModalSuccess
          showModalSuccess={showModalSuccess}
          closeModalSuccess={() => {
            setShowModalSuccess(false);
            fetchRemainingAttempts(); 
          }}
          fill="green"
          text="Plan de trabajo enviado correctamente"
        />

    <ModalAlertWarning
      showModalAlertWarning={showAlertWarning}
      closeModal={() => setShowAlertWarning(false)}
      error={alertMessage}
    />
    </div>
  );
}